import React from 'react';
import utils from '../src/scripts/utils/utils';
import Portfolio from '../src/scripts/containers/portfolio';
import NoPhotosHere from '../src/scripts/components/NoPhotosHere';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/styles/index.styl';

const SplashPage = ({ subdomain, operatorId }) => {
  if (subdomain || operatorId) {
    return <Portfolio subdomain={subdomain} operatorId={operatorId} isSalsa={true} />;
  }

  return <NoPhotosHere />;
};

SplashPage.getInitialProps = async ({ req, query }) => {
  const { operatorId } = query;

  let subdomain;
  if (req) {
    const domain = req.headers.host;
    if (domain && domain.includes('.')) {
      subdomain = domain.split('.')[0];
      if (!utils.isValidSubdomain(subdomain)) {
        subdomain = null;
      }
    }
  }

  return { subdomain, operatorId };
};

export default SplashPage;
